var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_409_5237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.2867 18.9412L64.0548 0.709382C63.1492 -0.232635 61.5213 -0.232473 60.6159 0.709382L42.3842 18.9412C41.6887 19.6366 41.4807 20.6826 41.857 21.5912C42.2334 22.4998 43.1201 23.0923 44.1035 23.0923H52.0901V80.5654C52.0901 81.9083 53.1789 82.9971 54.5218 82.9971H70.1491C71.492 82.9971 72.5808 81.9083 72.5808 80.5654V23.0923H80.5674C81.5509 23.0923 82.4377 22.4998 82.8139 21.5912C83.1902 20.6826 82.9822 19.6368 82.2867 18.9412Z",
    fill: "#671FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1039 33.8563H28.4766C27.1336 33.8563 26.0449 34.945 26.0449 36.288V80.5654C26.0449 81.9083 27.1336 82.997 28.4766 82.997H44.1039C45.4468 82.997 46.5355 81.9083 46.5355 80.5654V36.288C46.5355 34.945 45.4468 33.8563 44.1039 33.8563Z",
    fill: "#671FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.059 54.6927H2.43164C1.08873 54.6927 0 55.7815 0 57.1244V80.5654C0 81.9083 1.08873 82.997 2.43164 82.997H18.059C19.4019 82.997 20.4906 81.9083 20.4906 80.5654V57.1244C20.4906 55.7815 19.4019 54.6927 18.059 54.6927Z",
    fill: "#671FDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_409_5237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 83,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjection);
export default __webpack_public_path__ + "static/media/projection.edb4fd62ec9fcce5a7b9d845f11b2c5b.svg";
export { ForwardRef as ReactComponent };